const APP_NAME = {
	DIGIPLAN: 'DigiPlan',
	DIGIBULLETIN: 'DigiBulletin',
};

export { APP_NAME };
